module.exports = __webpack_public_path__ + "img/Kosar.c3e47be2.svg";